import { Link } from "react-router-dom";

export default function Logo({ className = "", variant = "white" }) {
    const src = variant === "black" ? "/logo/wordmark-trim.png" : "/logo/wordmark-white-trim.png";
    return (
        <Link to="/" data-testid="logo-link" className={`inline-flex items-center group ${className}`}>
            <img
                src={src}
                alt="Grow With Babur"
                className="h-7 sm:h-9 w-auto select-none"
                draggable={false}
            />
        </Link>
    );
}
